import React from 'react';
import { connect } from 'react-redux';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { ScrollContainer } from '@ff-os/shared-react/components/scroll-container/ScrollContainer';
import { WindowContext } from '@ff-os/shared-react/context/window/WindowContext';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { selectPinnedVariables } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { PrefabPreviewMode, PrefabWindowLayout } from '@ff-scene-plugins/gift-shared/GiftSceneOptions';
import classNames from 'classnames';
import { noop } from 'lodash';
import { selectPrefabPreviewMode, selectPrefabWindowLayout } from '../../_redux-scene';
import { useOrientation } from '../../context/Orientation';
import { usePreviewSize } from '../../context/PreviewSize';
import { PrefabPicker } from '../../prefab-picker/PrefabPicker';
import { VariableInputControlSlot } from '../../VariableInputControlSlot';
import { PrefabsWindowHeader } from '../mobile/partials/PrefabsWindowHeader';
import { GiftWindowStepProps } from '../shared/giftWindowSteps';
import { GiftWindowFooter } from '../shared/partials/GiftWindowFooter';
import styles from './DesignWindow.module.scss';

const _DesignWindow = ({
    onClose, previous, next,
    previousButtonText, nextButtonText,
    prefabPreviewMode, pinnedVariables,
    windowLayout
}: Props) => {

    const isMobile = useMobile();
    const orientation = isMobile ? 'screen' : windowLayout;
    useOrientation(orientation);
    usePreviewSize(prefabPreviewMode === 'full' && pinnedVariables.length === 0
        ? 'hidden'
        : 'small');

    return (
        <WindowContext isOpen close={noop}>
            <WindowContext.Header>
                <PrefabsWindowHeader previous={previous} onClose={onClose} />
            </WindowContext.Header>
            <WindowContext.Body>
                <Grid direction='column' gap='s' fullHeight className={styles[orientation]}>
                    {pinnedVariables.map(({ id }) => (
                        <Cell key={id} className={classNames(styles.cell, styles.controlCell)}>
                            <VariableInputControlSlot variableIds={[id]}
                                render={(Control) => (
                                    <div className={styles.control}>
                                        <Control />
                                    </div>
                                )} />
                        </Cell>
                    ))}

                    <Cell className={classNames(styles.cell, styles.scrollableCell)}>
                        <ScrollContainer maxHeight='100%'>
                            <PrefabPicker />
                        </ScrollContainer>
                    </Cell>
                </Grid>
            </WindowContext.Body>
            <WindowContext.Footer>
                <GiftWindowFooter
                    next={next} nextButtonText={nextButtonText}
                    previous={previous} previousButtonText={previousButtonText}
                    onClose={onClose} />
            </WindowContext.Footer>
        </WindowContext>
    );
};

type Props = GiftWindowStepProps & {
    pinnedVariables: GiftJson.Variable<any>[];
    prefabPreviewMode: PrefabPreviewMode;
    windowLayout: PrefabWindowLayout;
};

const mapStateToProps = (state: GiftPdpState) => ({
    prefabPreviewMode: selectPrefabPreviewMode(state),
    pinnedVariables: selectPinnedVariables(state),
    windowLayout: selectPrefabWindowLayout(state)
});

export const DesignWindow = connect(
    mapStateToProps
)(_DesignWindow);